import { Collapse, TableBody, TableCell, TableRow } from "@material-ui/core";
import { Check, GetApp } from "@material-ui/icons";
import React from "react";
import { getClickButton } from "../../../../functions/getButtons";
import { ICompanyEnvironmentIntegration } from "../../../../models/ICompanyEnvironment";
import { ICompanyEnvironmentIntegrationAccess } from "../../../../models/ICompanyEnvironmentIntegrationAccess";
import { getBoolIcon } from "../../functions/getBool";
import { getDate } from "../../functions/getDate";
import { FieldTable, FieldTableRow } from "../../style/IntegrationStyledComponents";
import { getAccessHeader } from "./TableHeaders";

interface IEnvironmentAccessProps {
  ea: ICompanyEnvironmentIntegration;
  objectFieldsOpen: boolean | undefined;
  index: number;
  confirmUpdate: (accessID: number, name: string, key: string) => void;
  getAPISecret: (accessID: number, name: string, key: string) => void;
}

export const getEnvironmentAccessRow = (props: IEnvironmentAccessProps) => {
  const { ea, objectFieldsOpen, index, confirmUpdate, getAPISecret } = props;

  const getSecretButton = (ia: ICompanyEnvironmentIntegrationAccess): JSX.Element => {
    let today = new Date();
    let expireDate = ia.ExpirationDate ? new Date(ia.ExpirationDate) : undefined;

    if (expireDate && today > expireDate) {
      return <></>;
    }

    if (ia.HasSecret) {
      return getClickButton("Update Secret", <GetApp />, async () => await confirmUpdate(ia.CompanyEnvironmentIntegrationAccessID, ia.Name, ia.Key));
    }
    return getClickButton("Get Secret", <GetApp />, async () => await getAPISecret(ia.CompanyEnvironmentIntegrationAccessID, ia.Name, ia.Key));
  };

  return (
    <TableRow>
      <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
        <Collapse in={objectFieldsOpen} timeout="auto" unmountOnExit>
          <FieldTable size="small">
            {getAccessHeader()}
            <TableBody>
              {ea.IntegrationAccesses.map((ia, iaIndex) => (
                <FieldTableRow key={`${index}.${iaIndex}`}>
                  <TableCell>{ia.Name}</TableCell>
                  <TableCell>{ia.Key}</TableCell>
                  <TableCell>{getBoolIcon(ia.IsActive)}</TableCell>
                  <TableCell>{getDate(ia.EffectiveDate)}</TableCell>
                  <TableCell>{getDate(ia.ExpirationDate)}</TableCell>
                  <TableCell>{getSecretButton(ia)}</TableCell>
                </FieldTableRow>
              ))}
            </TableBody>
          </FieldTable>
        </Collapse>
      </TableCell>
    </TableRow>
  );
};
